import React from 'react';
import {useRouter} from 'next/router';
export default function RecruitmentProcess({news}) {
    const router = useRouter();
    const {locale} = router;
    console.log(news);
    return (
        <section className="recruitment-process">
            {news.map(b => (
                <img src={locale === 'vn' ? b.image_url : b.image_url_en} />
            ))}
        </section>
    );
}
